import { useNavigate } from 'react-router-dom';

export default function usePeopleNavigator() {
  const navigate = useNavigate();

  const getViewPersonPageLink = (id: number) => `/people/${id}`;

  const openViewPersonPage = (id: number, state?: any) => {
    navigate(getViewPersonPageLink(id), state ? {
      state,
    } : undefined);
  };

  const openViewHistoryPage = (id: number) => {
    navigate(`/people/${id}/history`);
  };

  const openPeoplePage = () => navigate('/people');

  return {
    getViewPersonPageLink,
    openViewPersonPage,
    openViewHistoryPage,
    openPeoplePage,
  };
}
